import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Button, IconButton, Typography } from '@mui/material'
import I18n from 'i18n-js'
import { useEffect } from 'react'
import { ToolbarProps } from 'react-big-calendar'

const ToolBar = (props: ToolbarProps) => {
  /**The calendar does not provide any way to receive the range of dates that
   * are visible except when they change. This is the cleanest way I could find
   * to extend it to provide the initial range (`onView` calls `onRangeChange`).
   **/
  useEffect(() => {
    props.onView(props.view)
    /** This only needs to be called on the initial mount */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Box
      display="flex"
      alignItems={'center'}
      justifyContent="center"
      position="relative"
      paddingY={2}
    >
      <div style={{ position: 'absolute', left: 0 }}>
        <IconButton onClick={() => props.onNavigate('PREV')} size="small">
          <ChevronLeftIcon />
        </IconButton>
        <Button
          size="small"
          variant="outlined"
          onClick={() => props.onNavigate('TODAY')}
        >
          {I18n.t('calendar.today')}
        </Button>
        <IconButton onClick={() => props.onNavigate('NEXT')} size="small">
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Typography variant="h6">{props.label}</Typography>
    </Box>
  )
}

export default ToolBar
